import { render, staticRenderFns } from "./CatalogueView.vue?vue&type=template&id=56855339&scoped=true&"
import script from "./CatalogueView.vue?vue&type=script&lang=js&"
export * from "./CatalogueView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueView.vue?vue&type=style&index=0&id=56855339&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56855339",
  null
  
)

export default component.exports